import { useEffect, useState } from "react";
import api from "../../service/api";
import { CarrinhoDTO, ItemCarrinhoFiltroDTO } from "./useCarrinhoReducer";

export function useCarrinhoBusca(codcliente: number) {
  const [carrinho, setCarrinho] = useState<CarrinhoDTO>({
    Codcarrinho: 0,
    CodAlmoxarifado: 0,
    CodCliente: 0,
    CodEmpresa: 0,
    CodempresaCli: 0,
    CodUsuario: 0,
    DatCarrinho: "",
    Produtos: [],
    VlrMercadoria: 0,
    VlrDesconto: 0,
    CodSituacao: 0,
    qtdDisponivel: 0,
    vlrDisponivel: 0,
    qtdEncomenda: 0,
    vlrEncomenda: 0,
    QtdTotal: 0,
    VlrTotal: 0,
  });

  useEffect(() => {
    if (codcliente > 0) {
      api.get(`api/business/carrinho/${codcliente}`).then((response) => {
        // Desestrutura o objeto da API com somente os campos necessários na interface
        // e formata o valor para exibição
        const carrinho: CarrinhoDTO = response.data;

        // Seta os produtos no state para usar na página
        let vlrTotal = 0;

        for (let i = 0; i < carrinho.Produtos.length; i++) {
          // Lê o produto atual
          let produto = carrinho.Produtos[i];

          if (produto.Desconto == null) {
            produto.Desconto = 0;
          }
          // Calcula o total, multiplicando o valor do item pela quantidade dele no carrinho
          if (produto.VlrTotal) {
            vlrTotal +=
              produto?.VlrTotal - produto?.VlrTotal * (produto.Desconto / 100);
          }
          carrinho.Produtos[i].Src =
            process.env.REACT_APP_IMAGEMPATH + carrinho.Produtos[i].Src;
          if (produto.Qtd && produto.VlrTotal) {
            if (produto.Qtdestoque > 0) {
              if (produto.Qtd <= produto.Qtdestoque) {
                carrinho.qtdDisponivel += produto.Qtd;
                carrinho.vlrDisponivel += produto.VlrTotal;
              } else {
                carrinho.qtdDisponivel +=
                  produto.Qtd - (produto.Qtd - produto.Qtdestoque);
                carrinho.vlrDisponivel +=
                  (produto.VlrTotal / produto.Qtd) * produto.Qtdestoque;

                carrinho.qtdEncomenda += produto.Qtd - produto.Qtdestoque;
                carrinho.vlrEncomenda +=
                  (produto.VlrTotal / produto.Qtd) *
                  (produto.Qtd - produto.Qtdestoque);
              }
            } else {
              carrinho.qtdEncomenda += produto.Qtd - produto.Qtdestoque;
              carrinho.vlrEncomenda += produto.VlrTotal * produto.Qtd;
            }
          }

          carrinho.VlrTotal = vlrTotal;
          carrinho.QtdTotal = carrinho.qtdEncomenda + carrinho.qtdDisponivel;
          setCarrinho(carrinho);
          // localStorage.setItem('@VersaB2B:carrinho', JSON.stringify(contextCart));
        }
      });
    }
  }, []);
  return carrinho;
}

export function useCarrinhoSalvar(carrinhoFiltro: CarrinhoDTO): number {
  // let codcarrinho: number = 0;
  const [codCarrinho, setCodcarrinho] = useState<number>(0);

  useEffect(() => {
    if (carrinhoFiltro.Codcarrinho != 0) {
      setCodcarrinho(carrinhoFiltro.Codcarrinho!);
    } else {
      api.post(`api/business/criacarrinho`, carrinhoFiltro).then((response) => {
        setCodcarrinho(response.data);
      });
    }
  }, []);

  return codCarrinho;
}

export function useCarrinhoEsvaziar(Codcarrinho: number) {
  var filtro: ItemCarrinhoFiltroDTO = {
    Codacerto: Codcarrinho,
    Codcliente: 0,
  };

  api.post(`api/business/excluircarrinho`, filtro);
}

export function useCarrinhoItemSalvar(carrinhoFiltro: ItemCarrinhoFiltroDTO) {
  // useEffect(() => {
  api.post(`api/business/gravaitemcarrinho`, carrinhoFiltro).then(() => {});
  // }, []);
}
